export const loadMessages = async (locale: string) => {
  return Promise.resolve({});
};

export { messages } from './messages.js';
export { useMessage } from './useMessage.js';
